<!--Form-->
<div class="ehpr-MainGrid">
	<label>Pass Reason Code:</label>
	<input [disabled]="DisablePassCode()" id="PassReasonCode" [(ngModel)]="PassReasonCode" class="form-control" type="text" />

	<label>Pass Reason Description:</label>
	<input [disabled]="DisablePassDesc()" id="PassReasonDesc" [(ngModel)]="PassReasonDesc" class="form-control" type="text" />

	<label>Default Pass Duration (Minutes):</label>
	<input [disabled]="DisableDuration()" min="0" id="DefaultPassDur" [(ngModel)]="DefaultPassDur" class="form-control" type="number" />

	<label for="IsQuickPass">Is Quick Pass? (Limited Data Entry):</label>
	<input [disabled]="DisableQuickPass()" id="IsQuickPass" [(ngModel)]="IsQuickPass" class="form-control" type="checkbox" />

	<label for="IsGroupAssign">Is Group Assignable?:</label>
	<input [disabled]="DisableGroupAssign()" id="IsGroupAssign" [(ngModel)]="IsGroupAssign" class="form-control" type="checkbox" />

	<label for="IsAssignFromClass">Is Assignable from Classroom?:</label>
	<input [disabled]="DisableClassAssign()" id="IsAssignFromClass" [(ngModel)]="IsAssignFromClass" class="form-control" type="checkbox" />

	<label for="IsDistrictLevel">Is District Level?:</label>
	<input [disabled]="DisableDistLevel()" id="IsDistrictLevel" [(ngModel)]="IsDistrictLevel" class="form-control" type="checkbox" />

	<label for="UseClassAttnExcu">Use Class Attendance Excuse?:</label>
	<input [disabled]="DisableUseClassAttn()" id="UseClassAttnExcu" [(ngModel)]="UseClassAttnExcu" class="form-control" type="checkbox" />

	<label>Defined By:</label>
	<label class="ehpr-TypeText" [style.color]="GetTypeColor(DefinedByType)">{{ DefinedByType }}</label>
</div>

<!--Buttons-->
<div class="ehpr-Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
